import React from 'react'
import { func, bool, shape, string } from 'prop-types'
import { useDispatch } from 'react-redux'

import { appRoutes } from '../../configuration/constants'
import PayPalButton from '../../components/PayPal/PayPalButton'
import {
  fetchPaymentConfirmation,
  setPayPalPaymentConfirmation
} from '../../redux/paymentConfirmation/actions'
import { PAYMENT_CONFIRMATION_SUCCESS } from '../../redux/paymentConfirmation/constants'

const PayPalContainer = ({
  setPaymentError,
  loading,
  setLoading,
  paypalCreateParam,
  bookingConfirmationData,
  ferryId,
  handleRouteChange,
  labels,
  lang,
  onCancelTransaction
}) => {
  const dispatch = useDispatch()

  const handlePayPalResponse = response => {
    if (response?.status === 'COMPLETED') {
      const captureData = response?.purchase_units?.[0]?.payments?.captures?.[0]
      return dispatch(
        fetchPaymentConfirmation({
          bookingNumber: bookingConfirmationData?.bookingNumber,
          cardType: 'PP',
          amount: captureData?.amount?.value,
          currencyType: process.env.REACT_APP_PAYPAL_CURRENCY_CODE,
          orderId: response?.id,
          approvalCode: '',
          transactionNumber: captureData?.id,
          ferryId: ferryId,
          isPhonePayment: 'false',
          paymentProvider: 'PayPal'
        })
      ).then(res => {
        if (res?.type === PAYMENT_CONFIRMATION_SUCCESS) {
          dispatch(setPayPalPaymentConfirmation(response))
          handleRouteChange(appRoutes.bookingConfirmation.pathname)
        } else {
          setPaymentError(labels.genericPaymentErrorMessage)
        }
      })
    } else {
      setPaymentError(labels.genericPaymentErrorMessage)
    }
    setLoading(false)
  }

  return (
    <div className="payment-form-section">
      <PayPalButton
        lang={lang}
        createParam={paypalCreateParam}
        setLoading={setLoading}
        loading={loading}
        handleResponse={handlePayPalResponse}
        labels={labels}
        onCancelTransaction={onCancelTransaction}
      />
    </div>
  )
}

PayPalContainer.propTypes = {
  setPaymentError: func.isRequired,
  loading: bool.isRequired,
  setLoading: func.isRequired,
  paypalCreateParam: shape().isRequired,
  bookingConfirmationData: shape().isRequired,
  ferryId: string.isRequired,
  handleRouteChange: func.isRequired,
  labels: shape().isRequired,
  lang: string.isRequired,
  onCancelTransaction: func.isRequired
}

export default PayPalContainer
